




















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class'
import { GET_USER_INFO, GET_USER_TRANSACTIONS, USER_INFO } from "../store/constants";
import { DetailInfo, Transaction } from "../store/types";
import {EMAIL, USER_ID, USERNAME, ACCOUNT_ID, BALANCE} from "../../auth/store/constants";
import PlayerAvatar from '@/shared/components/ui/PlayerAvatar.vue';
import userService from '../services/UserService'

@Component({
    components: {
        PlayerAvatar
    },
})
export default class Profile extends Vue {
    @Getter(BALANCE) balance!: string;
    @Getter(USER_INFO) details!: DetailInfo;
    @Getter(ACCOUNT_ID) accountId!: number;
    @Action(GET_USER_INFO) getUserInfo!: Function;

    @Getter(USERNAME) username!: string;
    @Getter(USER_ID) userId!: string;
    @Getter(EMAIL) email!: string;

    private transactions = [];

    private footballStats = {};

    private async tryFetchUserData() {
        return new Promise((res, rej) => {
            const int = setInterval(() => {
                if (this.username) {
                    res(userService.fetchUser(this.username));
                    clearInterval(int)
                } else {
                    res(this.tryFetchUserData())
                }
            }, 500)
        })
    }

    private transactionsNextPage = '';
    private transactionsPreviousPage = '';

    private async mounted() {
        const data: any = await this.tryFetchUserData();
        this.footballStats = data.footballStats;
        this.getUserInfo();
        this.getTransactions();
    }

    private async getTransactions(type?: string) {
        let response;
        if (type === 'previous') {
            response = await userService.fetchUserTransactions(this.accountId, this.transactionsPreviousPage);
        } else {
            response = await userService.fetchUserTransactions(this.accountId, this.transactionsNextPage);
        }
        // @ts-ignore
        this.transactions = response.items;
        // @ts-ignore
        this.transactionsPreviousPage = response.previousPage;
        // @ts-ignore
        this.transactionsNextPage = response.nextPage;
    }
}
